export enum EvidenceOperationType {
  COMPLETE_ACCORDING_TO_THE_STANDARD_EMPLOYEE_FORGOT_CARD = 1,
  COMPLETE_ACCORDING_TO_THE_STANDARD_EMPLOYEE_USED_CARD_INCORRECTLY = 2,
  COMPLETE_ACCORDING_TO_THE_STANDARD_EMPLOYEE_MAKE_UP_FOR_LOST_WORK = 3,
  COMPLETE_ACCORDING_TO_THE_STANDARD_CUSTOM_COMMENT = 4,
}
